import { useQuery } from "@tanstack/react-query";
import { queryAircraft } from "../../apiNew";
import { Aircraft } from "../../../models/aircraft";

const useGetAircraft = (id: string): { data: Aircraft, isFetching: boolean, isError: boolean } => {
  const { data, isFetching, isError } = useQuery({
    queryKey: ['aircraft', id],
    queryFn: () => queryAircraft(id),
    enabled: !!id,
    refetchOnWindowFocus: false,
  });

  return { data: data?.data, isFetching, isError };
};

export default useGetAircraft;
